import { Component, OnInit } from '@angular/core';

import { AbastecimentoBemApiService } from "../shared/abastecimento-bem-api.service";
import { AbastecimentoBemService } from "../shared/abastecimento-bem.service";
import { AbastecimentoBemNavigationService } from "../shared/abastecimento-bem-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { abastecimentoBensModuleName } from "../shared/data.service";
import { AbastecimentoBem } from "../shared/abastecimento-bem.model";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { LocalService } from "../../locais/shared/local.service";
import { CombustivelApiService } from "../../combustiveis/shared/combustivel-api.service";
import { AreaApiService } from "../../../estruturas/areas/shared/area-api.service";
import { MotoristaApiService } from "../../../recursos-humanos/motoristas/shared/motorista-api.service";
import { Combustivel } from "../../combustiveis/shared/combustivel.model";
import { Area } from "../../../estruturas/areas/shared/area.model";
import { Motorista } from "../../../recursos-humanos/motoristas/shared/motorista.model";
import { LocalApiService } from "../../locais/shared/local-api.service";
import { FrotasService } from "../../../bens/frotas/shared/frota.service";
import { FrotaApiService } from "../../../bens/frotas/shared/frota-api.service";
import { frotasQuery } from "../../../bens/frotas/shared/data.service";
import { Local  } from "../../locais/shared/local.model";
import { Bomba } from "../../bombas/shared/bomba.model";
import { BombaApiService } from "../../bombas/shared/bomba-api.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";
import {Router} from "@angular/router";
import {FormaControleService} from "../../../bens/formas-controle/shared/forma-controle.service";

@Component({
    template: require('./abastecimento-bem-list.component.html'),
    styles: [require('./abastecimento-bem-list.component.css')]
})
export class AbastecimentoBemListComponent implements OnInit {
    list: AbastecimentoBem[] = [];
    loading: boolean = false;
    showDisabled: boolean = false;
    showAdvancedSearch: boolean = false;
    researched: boolean = false;
    abastecimentoBensModuleName: any = abastecimentoBensModuleName;
    search: any = {};
    tipoAbastecimentoExterno: number;
    tipoAbastecimentoInterno: number;
    tipoAbastecimentoConvenio: number;

    showFrotaLink: boolean = false;
    frotaDetailHistory: any = {};
    frotaRoute: string;
    frotasModule: any = {};

    locaisList: Local[] = [];
    bombasList: Bomba[] = [];
    combustiveisList: Combustivel[] = [];
    areasList: Area[] = [];
    motoristasList: Motorista[] = [];
    frotaSelectId: string = 'frota';
    frotaQuery: any = frotasQuery;

    constructor(
        private _abastecimentoBemApiService: AbastecimentoBemApiService,
        private _abastecimentoBemService: AbastecimentoBemService,
        private _abastecimentoBemNavigationService: AbastecimentoBemNavigationService,
        private _autocompleteService: AutoCompleteService,
        private _localApiService: LocalApiService,
        private _localService: LocalService,
        private _bombaApiService: BombaApiService,
        private _combustivelApiService: CombustivelApiService,
        private _areaApiService: AreaApiService,
        private _motoristaApiService: MotoristaApiService,
        private _frotaService: FrotasService,
        private _frotaApiService: FrotaApiService,
        private _utilService: UtilService,
        private _frotasService: FrotasService,
        private _frotaNavigationService: FrotaNavigationService,
        private _formaControleService: FormaControleService,
        private _router: Router
    ) { }

    ngOnInit() {
        let tipo: any = this._abastecimentoBemService.getTipoExterno();
        this.tipoAbastecimentoExterno = tipo.Key;
        tipo = this._abastecimentoBemService.getTipoInterno();
        this.tipoAbastecimentoInterno = tipo.Key;
        tipo = this._abastecimentoBemService.getTipoConvenio();
        this.tipoAbastecimentoConvenio = tipo.Key;

        this.getLocais();
        this.getBombas();
        this.getCombustiveis();
        this.getAreas();
        this.getMotoristas();

        this.search.local = null;
        this.search.combustivel = null;
        this.search.motorista = null;
        this.search.area = null;
        this.search.bem = 0;
        this.search.bomba = null;

        let datePicker: any = $('.input-datepicker');
        const t: any = this;
        datePicker.datepicker({
            onSelect: function(e: any) {
                t.changeSearch();
            }
        });

       this.testFrotaBackHistory();
    }

    clickNew() {
        this._abastecimentoBemService.clearSessionStorage();
        
        if (this.showFrotaLink) {
            this._frotaNavigationService.goToFrotaAbastecimentoNew(this.frotaRoute);
        } else {
            this._abastecimentoBemNavigationService.goToNew();
        }
    }

    clickEdit(item: AbastecimentoBem) {
        this._abastecimentoBemService.clearSessionStorage();

        if (this.showFrotaLink) {
            this._frotaNavigationService.goToFrotaAbastecimentoEdit(this.frotaRoute, item.id);
        } else {
            this._abastecimentoBemNavigationService.goToEdit(item.id);
        }
    }

    clickDelete(item: AbastecimentoBem) {
        let onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    clickGoToFrotaDetail() {
        this._frotasService.clearBackStorage();
        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
    }

    clickGoToFrotaList() {
        this._frotasService.clearBackStorage();
        this._frotaNavigationService.goToList(this.frotaRoute);
    }

    clickToggleAdvancedSearch() {
        $("#buscaAvancada").toggle("slow");
        this.showAdvancedSearch = !this.showAdvancedSearch;
    }

    changeSearch() {
        this.list = [];
        this.querySearch();
    }

    clickClearSearch() {
        this.search.local = null;
        this.search.combustivel = null;
        this.search.motorista = null;
        this.search.area = null;
        this.search.bem = 0;
        this.search.bomba = null;
        this.search.data_inicial = null;
        this.search.data_final = null;
        let date:any;
        date = document.getElementById('data_inicial');
        date.value = null;
        date = document.getElementById('data_final');
        date.value = null;

        this._autocompleteService.setValueOnSelect2(null, "frota");
    }

    getFrotasObject(object: any) {
        if (object.id) {
            this.search.bem = object.id;
        } else {
            this.search.bem = 0;
        }
        this.changeSearch();
    }

    frotaTemplateResult = (function(state: any) {
        let template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    private querySearch() {
        let dateStart: any;
        let dateEnd: any;

        let Query: any = [];

        if (this.search.local) {
            Query.push({
                localId: this.search.local
            });
        }

        if (this.search.bomba) {
            Query.push({
                bombaId: this.search.bomba
            });
        }

        if (this.search.combustivel) {
            Query.push({
                combustivelId: this.search.combustivel
            });
        }

        if (this.search.area) {
            Query.push({
                areaId: this.search.area
            });
        }

        if (this.search.motorista) {
            Query.push({
                motoristaId: this.search.motorista
            });
        }

        if (this.search.bem) {
            Query.push({
                bemId: this.search.bem
            });
        }

        dateStart = document.getElementById('data_inicial');
        if (dateStart.value) {
            dateStart = this._utilService.convertStringToDate(dateStart.value);
        }

        dateEnd = document.getElementById('data_final');

        if (dateEnd.value) {
            dateEnd = this._utilService.convertStringToDate(dateEnd.value);
        }

        if (dateStart instanceof Date) {
            Query.push({data:{'gte':dateStart}});
        }

        if (dateEnd instanceof Date) {
            Query.push({data:{'lte':dateEnd}});
        }

        if (Query.length) {
            this.loading = true;
            Query = {and: Query};
            this._abastecimentoBemApiService.onGetQuery(Query, this.onDoneSearch);
        }

        //envio: - dataInicial - dataFinal - bemId - localId - combustivelId - areaId - tanqueId - motoristaId - bombaId - orgaoId - tipoLancamento
        //ex. {"tanqueId": 1, "and":[{"data":{"gte":"2017-01-23T13:09:44.377Z"}}, {"data": {"lte":"2018-01-23T13:09:44.377Z"}}, {"bemId": 3}]}
    }

    private onDelete(item: any) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._abastecimentoBemApiService.onDelete(item.id, onDone);
    }

    private getLocais() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x:number, lenX:number,
                    list: any[] = [];

                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        Response[x].tipo = this._localService.getTipoLocal(Response[x].tipo);
                        list.push(Response[x]);
                    }
                }

                this.locaisList = list;
            }
        }.bind(this));

        this._localApiService.onGetAll(onDone);
    }

    private getBombas() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x:number, lenX:number,
                    list: any[] = [];

                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.bombasList = list;
            }
        }.bind(this));

        this._bombaApiService.onGetAll(onDone);
    }

    private getCombustiveis() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x:number, lenX:number,
                    list: any[] = [];

                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.combustiveisList = list;
            }
        }.bind(this));

        this._combustivelApiService.onGetAll(onDone);
    }

    private getAreas() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x:number, lenX:number,
                    list: any[] = [];

                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.areasList = list;
            }
        }.bind(this));

        this._areaApiService.onGetAll(onDone);
    }

    private getMotoristas() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x:number, lenX:number,
                    list: any[] = [];

                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.motoristasList = list;
            }
        }.bind(this));

        this._motoristaApiService.onGetAll(onDone);
    }

    private onDoneSearch = (function(Response: any) {
        if (!Response.error)  {
            this.list = [];

            let x:number, lenX:number,
                list: any[] = [];

            for (x = 0, lenX = Response.length; x < lenX; x++) {
                if (Response[x].local) {
                    if (Response[x].local.tipo) {
                        Response[x].local.tipo = this._localService.getTipoLocal(Response[x].local.tipo);
                    }
                }
                Response[x].formatDate = this._utilService.convertDateToString(Response[x].data);
                list.push(Response[x]);
            }

            this.list = list;
            this.researched = true;
        }
        this.loading = false;
    }.bind(this));

    private testFrotaBackHistory() {
        const settings: any = this._frotaService.testBackHistory('frota');

        this.frotaDetailHistory = settings.frotaDetailHistory;
        this.frotasModule = settings.frotasModule;
        this.frotaRoute = settings.frotaRoute;
        this.showFrotaLink = settings.showFrotaLink;

        if (this.showFrotaLink) {
            this.search.bem = this.frotaDetailHistory.id;
            this.changeSearch();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimento-bens/abastecimento-bem-list/abastecimento-bem-list.component.ts
 **/